import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../../ReducerRegister";
import EditService from "../../../../../services/screens/admin/dictionary/pinyin/EditService";
import { ActionTypes } from "../../../../actionTypes/screens/admin/dictionary/pinyin/EditActionTypes";
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.pinyin.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: pinyin => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, pinyin });

            EditService.loadScreenView(
                pinyin,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    savePinyinAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_PINYIN_ASYNC, vo });

            EditService.savePinyin(
                vo,
                response => {
                    dispatch(Actions.savePinyinSuccess(response));
                },
                error => {
                    dispatch(Actions.savePinyinFailure(error));
                }
            );
        };
    },

    savePinyinSuccess: data => ({
        type: ActionTypes.SAVE_PINYIN_SUCCESS,
        parentType: ActionTypes.SAVE_PINYIN_ASYNC,
        data
    }),

    savePinyinFailure: error => ({
        type: ActionTypes.SAVE_PINYIN_FAILURE,
        parentType: ActionTypes.SAVE_PINYIN_ASYNC,
        error
    }),



    createPinyin: () => ({
        type: ActionTypes.CREATE_PINYIN
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    pinyin: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, pinyin: data.pinyin };
};

const createPinyinReducer = (state) => {
    return { ...state, pinyin: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_PINYIN_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_PINYIN_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_PINYIN_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_PINYIN]: createPinyinReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
